module.exports = __webpack_public_path__ + "media/images/icons/pandp_icon-52a704c94536db0b72912aec6b950fbb.svg";